<script>
  import KayakListItem from '@/features/kayaks/list/presentation/components/KayakListItem'
  export default {
    name: 'kayaks',
    components: {
      KayakListItem,
    },
    data () {
      return {
        items: []
      }
    },
    methods: {
      getKayaks() {
        var json = require('@/assets/data/json/kayaks/list/kayaks.json');
        this.items = json
      },
      sortKayaksByName(items) {
        items.sort(function(a, b) {
          var nameA = a.name.toUpperCase();
          var nameB = b.name.toUpperCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
      }
    },
    mounted () {
      this.getKayaks()
      this.sortKayaksByName(this.items)
    }
  }
</script>
<template>
  <b-container
    class="main-content mb-5">
    <b-row>
      <kayak-list-item
        v-for="item in items"
        :key="item.id"
        :item="item">
      </kayak-list-item>
    </b-row>
  </b-container>
</template>
